import './AppSearch.scss';

import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import { FormControl } from 'react-bootstrap';
import IconButton from './IconButton';

type Props = {
  value: string;
  onChange: React.ChangeEventHandler<HTMLInputElement> | any ;
  placeholder?: string;
  className?: string;
}

export default function AppSearch({ value, onChange, placeholder, className }: Props) {

  function resetSearch() {
    const resetEvent = { type: "change", _reactName: 'onChange', target: { value: "" } }
    onChange(resetEvent)
  }

  return (
    <div className={`app-search ${className}`}>
      <FontAwesomeIcon className="search-icon" icon={solid('search')} />
      <FormControl
        size="sm"
        placeholder={placeholder || "Search for..."}
        value={value}
        onChange={onChange}
      />
      {value.length > 0 && (
        <IconButton className="remove-button">
          <FontAwesomeIcon icon={solid('times')} onClick={resetSearch} />
        </IconButton>
      )}
    </div>
  )
}